import { useAuth0 } from '@auth0/auth0-react'
import { useQuery } from '@tanstack/react-query'

import { setAccessToken as setAccessTokenApi } from '../../gateways/api'
import type { AuthenticatedUser } from '../types/AuthenticatedUser'
import { createAuthenticatedUser } from '../user'

export const useAuthenticatedUser = (): AuthenticatedUser => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()

  const { data: accessToken } = useQuery({
    queryKey: ['accesstoken'],
    queryFn: async () => {
      const token = await getAccessTokenSilently()

      setAccessTokenApi(token)

      return token
    },
    enabled: isAuthenticated,
  })

  return createAuthenticatedUser({
    ...user,
    accessToken,
  })
}
